// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"b6f8042c","344":"e06a7278","455":"88acddda","509":"c60f2b9e","722":"f9825027","896":"444ef7c4","910":"81a82034","967":"7f179a48","977":"5bfe35aa"}[chunkId] + ".chunk.js";
};